module.exports = __webpack_public_path__ + "img/视角旋转对齐.6ab34d7a.png";